module.exports = __webpack_public_path__ + "static/visual_3_1_eg-d961dcc02f4c9c8353d2c7746c23a4ae.png";